import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VehicleIdentityCardReport } from '../components/vehicle-identity/vehicle-identity.component';

@Injectable()
export class ReportService {

    constructor(private http: HttpClient) { };

    /**
     * Generazione report carta identità veicolo
     */
    sendJsonReportToStimulsoft(reportInfo: VehicleIdentityCardReport): Observable<any> {
        let jsonFile: any;
        jsonFile = JSON.stringify(reportInfo);
        let url = 'https://test.sdmain.com/wm/api/api/Reports/GetVic';
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let opts = { headers: headers, responseType: 'arraybuffer' as 'json' };
        return this.http.post<any>(url, jsonFile, opts)
    }

}

